export default __webpack_public_path__ + "static/media/warterMarkerHeight.1cf5c1b0.png";